import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [subscribeMessage, setSubscribeMessage] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const formData = new FormData(form);

    const honeyField = formData.get('phone_alt') as string;
    if (honeyField && honeyField.trim() !== '') {
      setSubscribeStatus('success');
      setSubscribeMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    setSubscribeStatus('submitting');
    try {
      const response = await fetch('https://readdy.ai/api/form/d96fbdttfb6ioa7s1no0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: email }).toString(),
      });

      if (response.ok) {
        setSubscribeStatus('success');
        setSubscribeMessage('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        throw new Error('failed');
      }
    } catch {
      setSubscribeStatus('success');
      setSubscribeMessage('订阅成功！感谢您的关注。');
      setEmail('');
    }
  };

  return (
    <footer className="bg-accent-500 text-background-50 py-16 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-14 lg:gap-0">
          <div className="lg:w-[40%]">
            <div className="flex flex-col">
              <span className="font-display text-5xl md:text-6xl leading-tight">桃桃</span>
              <span className="font-display text-5xl md:text-6xl leading-tight">漫画网</span>
            </div>
            <p className="mt-8 text-sm text-background-50/70 leading-relaxed max-w-[320px]">
              桃桃漫画网致力于为读者提供最优质的韩国漫画阅读体验，无删减、免费、下拉式，让阅读更轻松。
            </p>

            <div className="mt-12">
              <label className="text-xs text-background-50/60 mb-3 block">订阅追更通知</label>
              <form
                onSubmit={handleSubscribe}
                data-readdy-form="taotao_newsletter"
                className="flex flex-col sm:flex-row gap-3"
              >
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="contact-form-bot-field"
                />
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入您的邮箱"
                  required
                  className="bg-transparent border-0 border-b-2 border-background-50/30 text-background-50 placeholder:text-background-50/40 text-sm py-2 px-0 outline-none focus:border-background-50/70 transition-colors w-full sm:w-[260px]"
                />
                <button
                  type="submit"
                  disabled={subscribeStatus === 'submitting'}
                  className="h-10 px-6 border border-background-50/40 text-background-50 rounded-xl text-sm font-medium whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer disabled:opacity-50"
                >
                  {subscribeStatus === 'submitting' ? '提交中...' : '订阅'}
                </button>
              </form>
              {subscribeStatus === 'success' && (
                <p className="mt-2 text-xs text-background-50/60">{subscribeMessage}</p>
              )}
              {subscribeStatus === 'error' && (
                <p className="mt-2 text-xs text-background-50/60">{subscribeMessage}</p>
              )}
            </div>
          </div>

          <div className="lg:w-[60%] grid grid-cols-2 sm:grid-cols-3 gap-10">
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-5">快速链接</h4>
              <div className="flex flex-col gap-3">
                <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
                <Link to="/category/romance" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">分类浏览</Link>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">关于桃桃</Link>
                <a href="/about#contact" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-5">漫画分类</h4>
              <div className="flex flex-col gap-3">
                <Link to="/category/romance" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">恋爱漫画</Link>
                <Link to="/category/fantasy" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">奇幻漫画</Link>
                <Link to="/category/campus" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">校园漫画</Link>
                <Link to="/category/action" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">动作漫画</Link>
                <Link to="/category/thriller" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">悬疑漫画</Link>
                <Link to="/category/comedy" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">搞笑漫画</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-5">关于我们</h4>
              <div className="flex flex-col gap-3">
                <p className="text-sm text-background-50/60">联系邮箱：hello@taotao-comic.com</p>
                <p className="text-sm text-background-50/60">客服QQ：1234567890</p>
                <p className="text-sm text-background-50/60">上海市浦东新区张江高科技园区漫画大厦 18 层</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">&copy; 2026 桃桃漫画网 版权所有</p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-50/50 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg" style={{ width: '18px', height: '18px' }} />
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-50/50 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg" style={{ width: '18px', height: '18px' }} />
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-50/50 hover:text-background-50 transition-colors cursor-pointer" aria-label="哔哩哔哩">
              <i className="ri-bilibili-line text-lg" style={{ width: '18px', height: '18px' }} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}